
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableHeader, 
  TableRow 
} from "@shadcn/components/ui/table";

const TopBottomTable = ({ 
  data, 
  region, 
  title, 
  getStockToMonthLevelColor 
}) => {
  if (!data || data.length === 0) {
    return (
      <div className="text-center py-6 text-gray-500">
        No data available for {title}
      </div>
    );
  }

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">{title}</h3>
      <div className="overflow-x-auto overflow-y-auto max-h-[600px] border rounded-lg shadow-sm">
        <Table className="w-full border">
          <TableHeader className="bg-gray-100 sticky top-0 z-10">
            <TableRow>
              <TableHead className="px-2 sticky top-0 bg-gray-100 border-b border-gray-200">SKU</TableHead>
              <TableHead className="px-2 sticky top-0 bg-gray-100 border-b border-gray-200">Product Name</TableHead>
              <TableHead className="px-2 sticky top-0 bg-gray-100 border-b border-gray-200">Color/Variant</TableHead>
              <TableHead className="px-2 text-right sticky top-0 bg-gray-100 border-b border-gray-200">Quantity</TableHead>
              <TableHead className="px-2 text-right sticky top-0 bg-gray-100 border-b border-gray-200">{region} SOH</TableHead>
              <TableHead className="text-right sticky top-0 bg-gray-100 border-b border-gray-200">ST</TableHead>
              {region === 'AU' && (
                <>
                  <TableHead className="text-right sticky top-0 bg-gray-100 border-b border-gray-200">{region} Online</TableHead>
                  <TableHead className="text-right sticky top-0 bg-gray-100 border-b border-gray-200">{region} Retail</TableHead>
                  <TableHead className="text-right sticky top-0 bg-gray-100 border-b border-gray-200">{region} Online %</TableHead>
                  <TableHead className="text-right sticky top-0 bg-gray-100 border-b border-gray-200">{region} Retail %</TableHead>
                </>
              )}
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((item, index) => (
              <TableRow key={`${title}-${index}`} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                <TableCell className="font-medium">{item.sku}</TableCell>
                <TableCell className='max-w-[200px]'> {item.productName}</TableCell>
                <TableCell className>{item.color}</TableCell>
                <TableCell className="text-center font-semibold">{item.mtd}</TableCell>
                <TableCell className={`text-center ${getStockToMonthLevelColor(item.soh)}`}>
                  {item.soh}
                </TableCell>
                <TableCell className="text-right">{item.st}%</TableCell>
                {region === 'AU' && (
                  <>
                    <TableCell className="text-center">{item.onlineQuantity}</TableCell>
                    <TableCell className="text-center">{item.retailQuantity}</TableCell>
                    <TableCell className="text-center">{item.onlinePercentage}%</TableCell>
                    <TableCell className="text-center">{item.retailPercentage}%</TableCell>
                  </>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default TopBottomTable; 
